import { useCallback, useMemo } from 'react';
import { useMatch } from 'react-router-dom';
import { toast } from 'react-toastify';
import { switchUserTournament } from 'modules/auth/store/actions';
import { Pages } from 'modules/navigation/domain/enums/pages';
import { useAppDispatch } from 'store/hooks';
import { useGetOrganizerByIdQuery } from 'shared/api/organizers-api';

export function useOrganizerById() {
  const dispatch = useAppDispatch();
  const match = useMatch(Pages.ORGANIZERS.VIEW);
  const id = Number(match?.params?.id ?? -1);

  const { data: organizer, isLoading, isError } = useGetOrganizerByIdQuery(id, { skip: id <= 0 });

  const switchOrganizer = useCallback(() => {
    if (organizer?.id) {
      dispatch(switchUserTournament(organizer.id));
    } else {
      toast.error('Невозможно переключиться, обновите страницу');
      console.error('organizer id is undefined', { organizer });
    }
  }, [organizer, dispatch]);

  return useMemo(
    () => ({ organizer, isLoading, isError, id, switchOrganizer }),
    [organizer, isLoading, isError, id, switchOrganizer],
  );
}
